import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { findUsedGcmConsentTypes } from "@devowl-wp/cookie-consent-web-client";
import { HTML_ATTRIBUTE_CONFIRM } from "@devowl-wp/headless-content-unblocker";
import { yieldLazyLoad } from "@devowl-wp/react-utils";
import { BlockerHeroDialog } from "./hero/dialog.js";
import { BlockerHeroContainer } from "./heroContainer.js";
import { BlockerTextContainer } from "./textContainer.js";
import { useBlocker } from "../../contexts/blocker.js";
import { useStylesheetProvider } from "../../contexts/stylesheet.js";
import { useBlockerClassName } from "../../hooks/blocker/useBlockerClassName.js";
import { useBlockerMissingServices } from "../../hooks/blocker/useBlockerMissingServices.js";
import { useA11yId } from "../../hooks/useA11yId.js";
import { useMainStylesheetForContext } from "../../hooks/useMainStylesheetForContext.js";
const YieldBlockerTextContainer = yieldLazyLoad(Promise.resolve(BlockerTextContainer));
const YieldBlockerHeroContainer = yieldLazyLoad(Promise.resolve(BlockerHeroContainer));
const Blocker = (param)=>{
    let { skipInitialConsent } = param;
    const stylesheet = useMainStylesheetForContext();
    const { description: id } = stylesheet.reactRootSymbol;
    const { recorder, isGcm, blocker: { visualType, visualThumbnail }, blockedNode, createBefore, updateGcmConsentTypeChecked } = useBlocker();
    const [StylesheetProvider, stylesheetContextValue] = useStylesheetProvider(stylesheet);
    const useClassName = useBlockerClassName(stylesheet);
    const a11yExpanded = useA11yId(stylesheet);
    const missingServices = useBlockerMissingServices();
    // Prefill requested consent types
    useEffect(()=>{
        if (process.env.PLUGIN_CTX === "pro" && isGcm && !skipInitialConsent) {
            /* onlypro:start */ findUsedGcmConsentTypes(missingServices).forEach((type)=>updateGcmConsentTypeChecked(type, true));
        /* onlypro:end */ }
    }, [
        isGcm,
        skipInitialConsent
    ]);
    // Automatically start recorder if one exists
    useEffect(()=>{
        if (recorder) {
            recorder.restart();
            return ()=>{
                recorder.toggle(false);
            };
        }
        return ()=>{
        // Silence is golden.
        };
    }, []);
    const attr = {
        id: a11yExpanded
    };
    const dialogAttr = {
        blockerClassName: useClassName,
        blockerOverlayId: `${id}-o`
    };
    return /*#__PURE__*/ _jsx(StylesheetProvider, {
        value: stylesheetContextValue,
        children: (blockedNode == null ? void 0 : blockedNode.hasAttribute(HTML_ATTRIBUTE_CONFIRM)) ? /*#__PURE__*/ _jsx(BlockerHeroDialog, {
            ...dialogAttr,
            heroContainerRef: {
                current: // `createBefore` could be different to `blockedNode` e.g. when using `confirm()` together with `visualParent()`
                createBefore || blockedNode
            }
        }) : /*#__PURE__*/ _jsx("div", {
            className: useClassName,
            id: id,
            children: process.env.PLUGIN_CTX === "pro" && visualType === "hero" && visualThumbnail ? /*#__PURE__*/ _jsx(YieldBlockerHeroContainer, {
                ...dialogAttr,
                ...attr
            }) : /*#__PURE__*/ _jsx(YieldBlockerTextContainer, {
                ...attr
            })
        })
    });
};
export { Blocker };
